module.exports = __webpack_public_path__ + "img/icon-iosC-3.645dc198.png";